import React from 'react'
import StepCards from '../stepCards/StepCards'
import step1 from "../../images/ae-journey/ae1.png";
import step2 from "../../images/ae-journey/ae2.png";

import step3 from "../../images/step2.png";
import step4 from "../../images/ae-journey/ae3.png";
import step5 from "../../images/ae-journey/ae4.png";
import img5 from "../../images/ae-journey/ae5.png";


export default function AAMCJourney() {
    const stepCardContent = [
        {
          title: "Step 1",
          bodycopy: "Request for account creation.",
          img: step1,
        },
        {
          title: "Step 2",
          bodycopy: "To create your account, secure the required approval.",
          img: step2,
        },
        {
          title: "Step 3",
          bodycopy: "Login into the application.",
          img: step3,
        },
        {
          title: "Step 4",
          bodycopy:
            "Publish products to social onMarketplace and iaaMarketplace.",
          img: step4,
        },
        {
          title: "Step 5",
          bodycopy:
          "Create own growers.",
          img: img5,
        },
        {
            title: "Step 6",
            bodycopy:
              "Become a brand & publish to onMarketplace.",
            img: step5,
          },
      ];
  return (
    <>
    <h2 className="text-center container-title mb-4">
 Journey
  </h2>
    <div className='section3BodyContainer justify-content-md-center p-0 pb-5'>
         
    {stepCardContent.map((e) =>{
               return (
                <StepCards
                  src={e.img}
                  stepTitle={e.title}
                  stepContent={e.bodycopy}
                />
              );
        })}    </div>
        </>
  )
}
